import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ClientService } from '../../services/client.service';
import { UtilityService } from '../../services/utility.service';
import * as _ from 'lodash';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
declare var what3words: any;


@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.scss']
})
export class AddSiteComponent implements OnInit {

  locationForm: FormGroup
  isMapEdit = false
  isEdit = false
  latitude: number;
  longitude: number;
  address: any;
  loading: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    public formBuilder: FormBuilder,
    public _clientService: ClientService,
    public _utilityService: UtilityService
  ) { }

  ngOnInit() {
    console.log("DATA OF MODEL", this.data);
    if (this.data && this.data.siteData) {
      this.longitude = this.data.siteData.locationGeometry.coordinates[0]
      this.latitude = this.data.siteData.locationGeometry.coordinates[1]
      this.isMapEdit = true
      this.isEdit = true
    }
    this.createForm(this.data.siteData)
  }


  // FORM CONTROL 


  // Create Formgroup for sites (Location)
  createForm(data?) {
    this.locationForm = new FormGroup({
      title: new FormControl((data && data.title) ? data.title : ''),
      locationType: new FormControl((data && data.locationType) ? data.locationType : this.data.type),
      coordinates: new FormControl((data && data.locationGeometry) ? data.locationGeometry.coordinates : []),
      address: this.formBuilder.array(this.addresList(data && data.address && data.address.length ? data.address : [])),
      what3words: new FormControl((data && data.what3words) ? data.what3words : '')
    })
  }

  // Get address list from formgroup
  getAddressList() {
    return this.locationForm.get('address') as FormArray;
  }

  // Generate formarray for address list
  addresList(address) {
    if (address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl((singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title),
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl('')
      })]
    }
  }

  // UTILITY


  // Set current Location in form group
  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.locationForm.patchValue({
      coordinates: [this.longitude, this.latitude],
      // title: this.address,
    })
    this.getAddressList().clear()
    this.updateAddressData(splitAddress)
    this.getWhat3words(this.latitude, this.longitude)
  }

  // Generate What3words for selected location
  getWhat3words(latitude, longitude) {
    what3words.api.convertTo3waGeoJson({ lat: latitude, lng: longitude }, 'en').then((words) => {
      console.log("This is the word for rajkot", words);
      this.locationForm.patchValue({ what3words: { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words } })
      console.log("FORM VALUE", this.locationForm.value);
    })
  }

  // Update the address details in array formate
  updateAddressData(address) {
    console.log("WHat is the address array", address);
    const control = this.getAddressList()
    address.forEach(element => {
      console.log("This is the single element", element);
      control.push(
        this.formBuilder.group({
          title: element
        })
      )
    });
  }

  // Change location using drag and drop and update location
  changeLocation(location, inputIndex) {
    let element = []
    element.push(this.getAddressList().value.map((x) => { return x.title }))

  }





  // API CALL

  // Add or edit site for asset
  saveSite() {
    this.loading = true
    if (this.locationForm.valid) {


      if (this.isEdit) {
        console.log("THIS IS FOR EDIT", this.locationForm.value);
        let formData = this.locationForm.value
        formData['_id'] = this.data.siteData._id
        this._clientService.updateLocation(formData).subscribe((locationAdd) => {
          console.log("New location added", locationAdd);
          this.loading = false
          this.dialogRef.close(locationAdd)
        }, err => {
          console.log("Error while location add", err);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
        })
      } else {
        this._clientService.addLocation(this.locationForm.value).subscribe((locationAdd) => {
          console.log("New location added", locationAdd);
          this.loading = false
          this.dialogRef.close(locationAdd)
        }, err => {
          console.log("Error while location add", err);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
        })
      }
    } else {
      this.locationForm.markAllAsTouched()
      this.loading = false
    }
  }


  // Delete site 
  deleteSite() {
    let obj = {
      siteId: this.data.siteData._id,
      locationType: 'asset'
    }
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "site")
      .afterClosed().subscribe((confirm) => {
        if (confirm == '') return
        else if (confirm == 'yes') {
          this._clientService.deleteLocation(JSON.stringify(obj))
            .subscribe((data) => {
              this.dialogRef.close(data)
              this._utilityService.handleSnackBar({ msg: "Site deleted successfully!", button: "Ok" })
            }, (error) => {
              console.log('delete accident some error occure!!!', error)
              this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })

            })
        }
      })

  }


}
